import APP from '../../../main.js'
import Investment from './Investment'

class IssueInvestment extends Investment {
  get issue(){
    return this.constructor.employeeStore.issues.find(isx => isx.id === this.issue_id)
  }
  get deposit(){
    return this.constructor.employeeStore.deposits.find(dep => dep.id === this.deposit_id)
  }
  get deposit_name(){
    if(this.deposit){
      return this.deposit.name
    } else {
      return null
    }
  }
  get name(){
    if(this._name){return this._name}
    if(this.issue){
      return this._name = this.issue.name
    } else {
      return null
    }
  }
  set name(value){
    this._name = value
  }
  get crncy(){
    if(this.issue){
      return this.issue.crncy
    } else {
      return null
    }
  }
  get is_bond(){
    if(this.issue){
      return this.issue.bond
    } else {
      return false
    }
  }

  get asset_class_group(){
    return (this.issue || {}).asset_class_group()
  }
}

export default IssueInvestment
